import { MessageCircle, Sparkles, Heart } from "lucide-react";
import { useLocation } from "react-router-dom";

// Link WhatsApp SENZA messaggio precompilato
// La risposta automatica viene gestita tramite WhatsApp Business
const WHATSAPP_LINK = "https://wa.me/393202456998";

// Path su cui NON mostrare il widget WhatsApp (UI interna / app installata)
const HIDDEN_PATHS = ["/bacheca", "/magazzino"];

export default function WhatsAppButton() {
  const location = useLocation();
  if (HIDDEN_PATHS.some((p) => location.pathname.startsWith(p))) {
    return null;
  }
  return (
    <>
      <style>{`
        .whatsapp-float {
          position: fixed;
          bottom: 0;
          right: 0;
          background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
          color: white;
          border-radius: 20px 0 0 0;
          padding: 14px 24px 14px 18px;
          font-weight: 600;
          text-decoration: none;
          display: flex;
          align-items: center;
          gap: 10px;
          box-shadow: -4px -4px 15px rgba(0,0,0,0.2);
          z-index: 999999;
          animation: whatsapp-glow 3s infinite;
          transition: all 0.3s ease;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          font-size: 14px;
          min-width: 280px;
        }

        .whatsapp-float:hover {
          transform: translateY(-3px);
          box-shadow: -6px -6px 25px rgba(0,0,0,0.3);
          background: linear-gradient(135deg, #2be06f 0%, #15a085 100%);
        }

        .whatsapp-float svg {
          width: 22px;
          height: 22px;
          flex-shrink: 0;
        }

        .whatsapp-content {
          display: flex;
          flex-direction: column;
          line-height: 1.2;
        }

        .whatsapp-main {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 15px;
        }

        .whatsapp-sub {
          font-size: 11px;
          opacity: 0.9;
          font-weight: 400;
        }

        .whatsapp-badge {
          background: rgba(255,255,255,0.25);
          padding: 2px 8px;
          border-radius: 10px;
          font-size: 10px;
          font-weight: 500;
          margin-left: auto;
        }

        @keyframes whatsapp-glow {
          0%, 100% {
            box-shadow: -4px -4px 15px rgba(0,0,0,0.2), 0 0 20px rgba(37, 211, 102, 0.3);
          }
          50% {
            box-shadow: -4px -4px 15px rgba(0,0,0,0.2), 0 0 30px rgba(37, 211, 102, 0.5);
          }
        }

        /* Mobile */
        @media (max-width: 480px) {
          .whatsapp-float {
            min-width: 260px;
            padding: 12px 20px 12px 14px;
          }
          .whatsapp-main {
            font-size: 14px;
          }
        }
      `}</style>
      
      <a 
        href={WHATSAPP_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
        data-testid="whatsapp-button"
        aria-label="Contattaci su WhatsApp"
      >
        <MessageCircle />
        <div className="whatsapp-content">
          <span className="whatsapp-main">
            <span>Hai domande? Scrivici!</span>
          </span>
          <span className="whatsapp-sub">Rispondiamo in pochi minuti</span>
        </div>
        <span className="whatsapp-badge">Online</span>
      </a>
    </>
  );
}
